import { Grid, TextField } from '@mui/material';
import Box from '@mui/material/Box';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { validMessage } from '../../../../constants/ValidsFormConst';
import { useNotification } from '../../../../helpers/Notification';
import { LoadingWidget } from '../../../../widgets';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import SelectFieldProfesionesComponent from '../../../sistema/profesiones/components/SelectFieldProfesiones';
import { saveUsuProfesionesAction } from '../UsuProfesionesAction';

const FormUsuProfesiones = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const usuariosStore = Redux.useSelector((state) => state.usuarios);
  const usuProfesionesStore = Redux.useSelector(
    (state) => state.usuProfesiones,
  );

  const activo = usuProfesionesStore.activo;

  const initData = {
    oficio: '',
    desc: '',
    idProfesion: '',
    idEstatus: 1,
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    idProfesion: false,
    oficio: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);

  React.useEffect(() => {
    if (!activo) return;
    let values = {};
    Object.keys(data).map((key) => (values[key] = activo[key]));
    setTimeout(
      () =>
        setData({
          ...values,
          idProfesion: activo.profesion.id,
          idEstatus: activo.estatus.id,
        }),
      300,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (!usuariosStore.activo) {
      notify('Falta seleccionar us usuario', { warning: true });
      return;
    }
    if (_validDataForm()) {
      setLoadingSave(true);
      let res = await saveUsuProfesionesAction(
        { dispatch, notify },
        activo?.id,
        {
          ...data,
          idUsuario: usuariosStore.activo.id,
        },
        usuProfesionesStore.params,
      );
      if (res) setOpenModalForm(false);
      setLoadingSave(false);
    }
  };

  return (
    <Box component="form">
      <Grid container spacing={2}>
        {loadingSave && (
          <Grid item xs={12} md={12}>
            <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          </Grid>
        )}

        {!activo && (
          <Grid item xs={12} md={12}>
            <SelectFieldProfesionesComponent
              value={data.idProfesion}
              onChange={(id) => _handleSetDataField(CONST.profesion.idName, id)}
            />
          </Grid>
        )}

        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.oficio.name}
            required
            label={CONST.oficio.label}
            value={data.oficio}
            onChange={(e) =>
              _handleSetDataField(CONST.oficio.name, e.target.value)
            }
            helperText={dataError.oficio ? validMessage.required : null}
            error={dataError.oficio}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.desc.name}
            label={CONST.desc.label}
            value={data.desc}
            multiline
            rows={4}
            onChange={(e) =>
              _handleSetDataField(CONST.desc.name, e.target.value)
            }
          />
        </Grid>
        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            text={activo ? 'ACTUALIZAR' : 'GUARDAR'}
            disabled={loadingSave}
            green={!activo}
            blue={activo}
            saveIcon
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormUsuProfesiones;
